export const _COGNITO_ATTRIBUTE_S3_PATH = "custom:apiExtraS3Path";